import { withErrorBoundary } from 'react-error-boundary';
import InlinePageActionButton from 'components/generic/InlineButton/InlinePageActionButton';
import type { IconSize } from 'components/hoc/withIcon/shared/types';
import { mapSizes } from 'helpers/mappers';
import type { TypeInlineLinkDetailed } from 'types/autogen/contentful';
import { navigationLinkToPageAction } from '../../shared/ContentfulHelpers';

function mapIconSize(size: TypeInlineLinkDetailed['fields']['size']): IconSize {
    switch (size) {
        case 'xs':
            return { width: '16px', height: '16px' };
        case 'sm':
            return { width: '16px', height: '16px' };
        case 'lg':
            return { width: '24px', height: '24px' };
        default:
            return { width: '16px', height: '16px' };
    }
}

function InlineLink({ fields }: TypeInlineLinkDetailed) {
    const { variant, label, size, icon, iconPosition, link } = fields;

    const mappedSize = mapSizes({ xs: 'S', sm: 'M', lg: 'L' }, size);

    const inlineButtonProps = { variant, size: mappedSize };

    const linkAction = navigationLinkToPageAction(link);

    if (!linkAction) return null;

    if (icon) {
        const iconProperties = { position: iconPosition, size: mapIconSize(size) };
        const withIconProps = { ...inlineButtonProps, icon, iconProperties };
        return (
            <InlinePageActionButton.WithIcon action={linkAction} {...withIconProps}>
                {label}
            </InlinePageActionButton.WithIcon>
        );
    }

    return (
        <InlinePageActionButton action={linkAction} {...inlineButtonProps}>
            {label}
        </InlinePageActionButton>
    );
}

export default withErrorBoundary(InlineLink, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
